module.exports = __webpack_public_path__ + "img/Number=11.200b1ada.png";